import { useAppSelector } from '@hooks/reduxHooks.ts';

import ClientLogoStyled from './styled.tsx';

export const ClientImg = () => {
    const clientLogoURI = useAppSelector((s) => s.clientStatus.clientStatus?.clientLogoURI);

    return (
        <img
            src={clientLogoURI}
            alt={'client logo'}
            onError={(e) => {
                const img = e.currentTarget as HTMLImageElement;
                console.error('Failed to load:', img.src);
            }}
        />
    );
};

const ClientLogo = () => (
    // TODO this will come from API
    <ClientLogoStyled>
        <ClientImg />
    </ClientLogoStyled>
);

export default ClientLogo;
